export enum WooCommerceProductAddonType {
  CustomText = 'custom_text',
  CustomTextarea = 'custom_textarea',
  Checkbox = 'checkbox',
  MultipleChoice = 'multiple_choice'
}

export enum WooCommerceProductAddonDisplay {
  Select = 'select',
  RadioButton = 'radiobutton'
}
